import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TabsPageRoutingModule } from './tabs-routing.module';

import { TabsPage } from './tabs.page';
import { SubscribeModule } from '../modal/subscribe/subscribe.module';
import { ContentNotAvailableModule } from '../modal/content_not_available/content-not-available.module';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    TabsPageRoutingModule,
    // SubscribeModule,
    ContentNotAvailableModule
  ],
  declarations: [TabsPage]
})
export class TabsPageModule {}
